// mutations
export const UI_SET_SIZE = 'Set UI size'
export const UI_SET_PAGE = 'Set UI page'
export const UI_SET_TREE_OPEN = 'Set UI tree open'
export const UI_SET_SEARCH_OPEN = 'Set search open'
export const UI_SET_SEARCH_FOCUS = 'Set search focus'
export const UI_SET_SEARCH_TERM = 'Set search term'
export const UI_SET_THEME = 'Set theme'
export const UI_SET_DARKNESS = 'Set darkness'
export const UI_SET_SHOW_STRENGTH_INDICATOR = 'Set show strength indicator'
export const UI_SET_DRAG_DROP_VAULTS = 'Set drag and drop vaults'
export const UI_SET_SHOW_TOOLTIPS = 'Set show tooltips'
export const UI_SET_IS_ONLINE = 'Set is online'
export const UI_SET_LAST_URL = 'Set last URL'

// actions
export const INITIAL_CONNECT = 'Initial connect'
